import './App.css';
import AppRoutes from './routes/AppRoutes';
import { PrimeReactProvider } from 'primereact/api';
import { ToastProvider } from './contexts/ToastContext';
import "primereact/resources/themes/lara-light-cyan/theme.css";
import { CartProvider } from './contexts/CartProvider';
import { VendorProvider } from './contexts/VendorContext';
import { TransactionProvider } from './contexts/TransactionContext';
import { RCNProvider } from './contexts/RCNContext';
import { MenuAccessProvider } from './contexts/MenuAccessContext';
import { LotterySettingsProvider } from './contexts/LotterySettingsContext';

function App(){

    return (
        <PrimeReactProvider>
            <ToastProvider>
                <RCNProvider>
                    <MenuAccessProvider>
                        <CartProvider>
                            <VendorProvider>
                                <TransactionProvider>
                                    <LotterySettingsProvider>
                                        <AppRoutes />
                                    </LotterySettingsProvider>
                                </TransactionProvider>
                            </VendorProvider>
                        </CartProvider>
                    </MenuAccessProvider>
                </RCNProvider>
            </ToastProvider>
        </PrimeReactProvider>
    )
}

export default App;
